import { Form, Select } from "antd";
import { IOption } from "../../../../types/Option";
import { ITemplate } from "../../types";
import { useMemo } from "react";
import { DownloadSection } from "./DownloadSection";

type FormSelectProps = {
  contractNumber: string;
  isLoading: boolean;
  formItems: ITemplate[];
  templateId: string | undefined;
};

export const FormSelect = ({
  contractNumber,
  isLoading,
  formItems,
  templateId,
}: FormSelectProps) => {
  const options: IOption[] = useMemo(() => {
    return formItems.map((item: ITemplate) => ({
      value: item.id,
      label: item.name,
    }));
  }, [formItems]);

  const selectedItem: ITemplate | undefined = useMemo(() => {
    if (templateId) {
      const item = formItems.find((val: ITemplate) => val.id === templateId);

      return item || undefined;
    }

    return undefined;
  }, [formItems, templateId]);

  const style = useMemo(() => ({ width: "300px" }), []);

  return (
    <>
      <Form.Item name="templateId" className="mb-0" style={style}>
        <Select options={options} loading={isLoading} size="large" />
      </Form.Item>
      {selectedItem && (
        <DownloadSection
          contractNumber={contractNumber}
          selectedItem={selectedItem}
        />
      )}
    </>
  );
};
